import i18n from '@/utils/i18n';
import React from 'react';
import { Button } from './button';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface Props {
  message: string;
  onRetry?: () => void;
  testID: string;
}

export const CatalogCarouselItemsMessageRow: React.FC<Props> = ({
  message,
  onRetry,
  testID,
}) => {
  const [styles] = useStyles();

  return (
    <View style={styles.row} testID={testID}>
      <Typography flexShrink={1} variant="paragraph-base">
        {message}
      </Typography>
      {onRetry ? (
        <Button
          onPress={onRetry}
          size="small"
          testID="catalog-category-carousel-retry"
          trackingData={{ name: 'catalog.category_items_retry_button.press' }}
          type="secondary"
        >
          {i18n.t('retry')}
        </Button>
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  row: {
    alignItems: 'center',
    borderColor: theme.colors.stroke,
    borderRadius: 8,
    borderWidth: 1,
    flexDirection: 'row',
    gap: 16,
    justifyContent: 'space-between',
    padding: 16,
  },
}));
